import { SvgIcon } from "@material-ui/core";
import classNames from "classnames";
import React, { CSSProperties, useMemo } from "react";

import { IColor, IVariants, VARIANTS, useStyles } from "./Icon.style";

let idCounter = 0;
const generateId = () => `icon-title-${++idCounter}`;

export type IconProps = {
	variant?: IVariants;
	color?: IColor;
	width?: number;
	height?: number;
	className?: string;
	onClick?: (event: React.MouseEvent) => void;
	style?: CSSProperties;
	viewBox?: string;
	fill?: string;
	strokeWidth?: string | number;
	dataCy?: string;
	title?: string;
	ariaHidden?: boolean;
	deprecated?: boolean;
};

type IProps = IconProps & {
	children: string | React.ReactNode | React.ReactNode[];
};
export const Icon = React.forwardRef<SVGSVGElement, IProps>(
	(
		{
			variant = "medium",
			color = "primary",
			children,
			width = VARIANTS[variant ?? "medium"],
			height = VARIANTS[variant ?? "medium"],
			className,
			onClick,
			style,
			viewBox,
			fill,
			strokeWidth,
			dataCy,
			title,
			ariaHidden = false,
		},
		ref
	) => {
		const styles = useStyles({ variant, color, fill });
		const titleId = useMemo(() => (title ? generateId() : undefined), [title]);

		return (
			<SvgIcon
				ref={ref}
				className={classNames(styles.Root, className)}
				viewBox={viewBox ? viewBox : `0 0 ${width} ${height}`}
				fill={fill}
				strokeWidth={strokeWidth}
				stroke={strokeWidth ? "currentColor" : undefined}
				onClick={onClick}
				style={{ ...style, width: width, height: height }}
				data-cy={dataCy}
				role="img"
				aria-labelledby={title ? titleId : undefined}
				aria-hidden={ariaHidden}
			>
				{title && <title id={titleId}>{title}</title>}
				{children}
			</SvgIcon>
		);
	}
);
